module.exports = __webpack_public_path__ + "static/img/room3.883f3b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/room3.png
// module id = 0vOw
// module chunks = 0